<template>
    <div class="upsell-items">
        <!-- Flyer -->
        <v-card
            v-if="currentFlyer"
            class="upsell-item"
            elevation="2"
            :style="{ backgroundColor: currentFlyer.bg }"
        >
            <v-img
                :src="currentFlyer.url"
                contain
                class="product-image"
                height="100%"
                width="100%"
            >
            </v-img>  
        </v-card>
        <!-- Upsell Items -->
        <v-card
            v-for="item in upsellItems"
            :key="item.sku"
            class="upsell-item"
            elevation="2"
        >
            <v-img
                :src="getImageUrl(item.sku)"
                contain
                class="product-image"
                height="100%"
                width="100%"
            >
                <v-badge
                    v-if="item.qty > 1"
                    :content="`Menge: ${item.qty}`"
                    color="error"
                    class="quantity-badge"
                    location="top end"
                    offset-x="-4"
                    offset-y="8"
                ></v-badge>
            </v-img>  
        </v-card>
    </div>
</template>

<script>
import gravurfarbeImage from '@/assets/files/gravurfarbe_kinderbesteck.png'
import prioOrderImage from '@/assets/files/prio_order.png'

export default {
    name: 'UpsellItems',
    props: {
        upsellItems: {
            type: Array,
            default: () => []
        },
        currentFlyer: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            gravurfarbeImage
        }
    },
    methods: {
        getImageUrl(sku) {
            switch (sku) {
                case 'gravurfarbe_kinderbesteck':
                    return gravurfarbeImage;
                case 'PRIO_ORDER':
                    return prioOrderImage;
                default:
                    return `/api/files/sku?sku=${sku}`;
            }
        }
    },
    watch: {
        currentFlyer: {
            handler(newVal, oldVal) {
                console.log('UpsellItems - currentFlyer prop changed:', { old: oldVal, new: newVal });
            },
            immediate: true
        }
    }
}
</script>

<style>
.upsell-items {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 4px 0;
    scrollbar-width: thin;
}

.upsell-items::-webkit-scrollbar {
    height: 6px;
}

.upsell-items::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.upsell-items::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.upsell-items::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.upsell-item {
    width: clamp(60px, 12vw, 120px); /* Add max-width constraint to prevent oversizing */
    height: clamp(60px, 12vw, 120px);
    background-color: #f0f0f0;
    border-radius: 16px;
    border: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    flex-grow: 0;
    aspect-ratio: 1/1;
    padding: 4px;
}

/* Tablet optimization for touch interaction */
@media (min-width: 900px) and (max-width: 1199px) and (pointer: coarse) {
    .upsell-items {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
        gap: 8px;
        overflow-x: hidden;
        overflow-y: auto;
        max-height: 250px;
        width: 100%;
        box-sizing: border-box;
    }
    
    .upsell-item {
        width: 80px; /* Fixed size for consistent touch targets */
        height: 80px;
        min-width: 80px;
        max-width: 80px;
        aspect-ratio: 1/1; /* Perfect square for tablets */
        border-radius: 12px; /* Slightly smaller radius for compact look */
        padding: 4px;
        box-sizing: border-box;
        cursor: pointer; /* Better UX indication */
    }
    
    .upsell-item:hover {
        background-color: #e8e8e8; /* Touch feedback */
        transform: scale(1.02); /* Subtle hover effect */
        transition: all 0.2s ease;
    }
    
    /* Adjust badge positioning for smaller items */
    .quantity-badge {
        font-size: 11px !important;
    }
}

/* Tablet landscape specific optimization */
@media (min-width: 1024px) and (max-width: 1366px) and (orientation: landscape) and (pointer: coarse) {
    .upsell-items {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));
        gap: 6px;
        max-height: 200px; /* Smaller for landscape */
    }
    
    .upsell-item {
        width: 70px; /* Slightly smaller for landscape tablets */
        height: 70px;
        min-width: 70px;
        max-width: 70px;
        border-radius: 10px;
        padding: 3px;
    }
    
    /* Even smaller badge for landscape */
    .quantity-badge {
        font-size: 10px !important;
    }
}

/* Make upsell items smaller on desktop */
@media (min-width: 1200px) {
    .upsell-items {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        overflow-x: hidden;
        overflow-y: auto;
        max-height: 300px;
        gap: 4px;
        width: 100%;
        box-sizing: border-box;
    }
    
    .upsell-item {
        width: 100%;
        height: auto;
        min-width: 0;
        max-width: 100%;
        aspect-ratio: 1/1;
        border-radius: 4px;
        padding: 2px;
        box-sizing: border-box;
    }
}
</style>